<template>
  <div>
    <b-navbar
      ref="my-modal"
      type="dark"
      variant="info"
    >
      <b-navbar-nav>
        <b-nav-item
          href="/terms"
          target="_blank"
        >
          Terms
        </b-nav-item>
        <b-nav-item
          href="/regulation"
          target="_blank"
        >
          Regulation
        </b-nav-item>
        <b-nav-item>
          <b-nav-item
            v-b-modal.modal-support
          >
            Support
          </b-nav-item>
        </b-nav-item>
        <!-- <Locale /> -->
      </b-navbar-nav>
    </b-navbar>
    <!-- Modal Support-->
    <div class="modal-serv">
      <b-modal
        id="modal-support"
        ref="modal-support"
        modal-class="my-second-class"
        hide-footer
        hide-header
        centered
        body-class="p-0"
      >
        <h3
          class="title-support"
        >
          Contact Us
        </h3>
        <a
          class="btn-close"
          href="#"
          @click="hideModal"
        >
          <img
            :src="require('@/assets/images/close.png')"
            alt=""
          >
        </a>
        <hr>
        <div class="content-text">
          <div
            class="text-left"
          >
            <p>Email</p>
            <p>Call Center</p>
            <p>Our Office</p>
          </div>
          <div
            class="text-right"
          >
            <p>{{ dataInfo.email_support }}</p>
            <p>{{ dataInfo.call_center }}</p>
            <p v-html="dataInfo.office_address" />
          </div>
        </div>
        <div class="nav-comunication">
          <a
            :href="dataInfo.wa_support"
            target="_blank"
          >
            <img
              :src="require('@/assets/images/whatsapp-icon.png')"
              alt=""
            >
          </a>
          <a
            :href="setEmail(dataInfo.email_support)"
          >
            <img
              :src="require('@/assets/images/email-icon.png')"
              alt=""
            >
          </a>
          <a
            :href="setPhone(dataInfo.call_center)"
          >
            <img
              :src="require('@/assets/images/sms-icon.png')"
              alt=""
            >
          </a>
        </div>
        <div
          class="nav-download"
        >
          <b-button
            variant="primary"
            :href="dataInfo.user_guideline"
            target="_blank"
          >
            Download User Guidelines
          </b-button>
        </div>
      <!-- <profile-support :support-data="profileData.userSupport" /> -->
      </b-modal>
    </div>
  <!-- /Modal Support-->
  </div>
</template>

<script>
import {
  BNavbar,
  BNavItem,
  BNavbarNav,
  BModal,
  BButton,
  // BNavItemDropdown,
  // BDropdownItem,
  // BNavForm,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
// import Locale from '@/@core/layouts/components/app-navbar/components/Locale.vue'

export default {
  components: {
    BNavbar,
    BNavItem,
    BNavbarNav,
    BModal,
    BButton,
    // BNavItemDropdown,
    // BDropdownItem,
    // BNavForm,
    // Locale,
  },
  computed: {
    ...mapGetters('datas', {
      dataInfo: 'getDataInfo',
    }),
  },
  mounted() {
    //
  },
  methods: {
    hideModal() {
      this.$refs['modal-support'].hide()
    },
    openModal() {
      this.$refs['modal-support'].show()
    },
    setEmail(email) {
      return `mailto:${email}?subject=Help for IOH information&body=Hello IOH Support.%0D%0A%0D%0ACan you help me to explain all about IOH, please?%0D%0A%0D%0AThank you%0D%0AYour Valuable Partner.`
    },
    setPhone(phone) {
      return `tel:${phone}`
    },
  },
}
</script>

<style scoped>
.nav-link{
  color: #6E6B7B !important;
  padding: 0 16px 0 5px !important;
}
.navbar {
  padding-left: 0px !important;
  padding-right: 0px !important;
  font-family: 'Rubik';
  margin-top: 17px;
}
.bg-info {
  background-color: transparent !important;
}
.btn-close {
  position: absolute !important;
  right: 18px;
  top: 14px;
}
.title-support {
  margin-left: 20px;
  margin-top: 17px;
  font-family: 'Rubik';
  font-size: 20px;
  font-weight: bold;
  color: #4B6AAE;
}
.content-text {
  padding: 10px 20px 10px 20px !important;
  font-family: 'Rubik';
}
.text-left {
  float: left;
  font-size: 16px;
  color: #5E5873;
  margin-right: 100px;
}
.text-left > p {
  font-weight: bold;
}

.text-right {
  color: #4B6AAE;
}
.nav-comunication{
  position: absolute;
  bottom: -34px;
  padding-left: 10px;
}
.nav-download{
  position: absolute;
  bottom: -48px;
  padding-right: 10px;
  right: 0px;
}
.nav-comunication > a {
  margin-right: 16px;
}
</style>
